import { nanoid } from "nanoid";
import { ref } from "vue";

export function useSlateMessage(message = `Loading`, infix = `Loading`) {
	const id = ref(nanoid());

	const slateShowMessage = () => {
		/* global showMessage */
		showMessage(message, { id: id.value });
	};

	const slateHideMessage = () => {
		/* global hideMessage */
		hideMessage(id.value);
	};

	return {
		[`show${infix}Message`]: slateShowMessage,
		[`hide${infix}Message`]: slateHideMessage,
	};
}